import { useEffect, useRef, useState } from "react";

/**
 * PhotoConfirmButton — port of FE cũ.
 *
 * Click → 5 giây countdown → fire onConfirm. Có nút Hủy giữa lúc đếm.
 * `isPhoto` chỉ ảnh hưởng nhãn hiển thị (hoàn tất chụp vs hoàn tất makeup).
 *
 * Nhãn nói "hoàn tất ca", không hứa "gửi sửa hình": server chỉ đẩy đơn sang
 * sửa hình khi cả ekip đã xác nhận, nên người bấm trước chưa chuyển đơn.
 */
export function PhotoConfirmButton({
  onConfirm,
  isPhoto = true,
  disabled = false,
}: {
  onConfirm: () => void;
  isPhoto?: boolean;
  disabled?: boolean;
}) {
  const [countdown, setCountdown] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const start = () => {
    setCountdown(5);
    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          if (timerRef.current) clearInterval(timerRef.current);
          onConfirm();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const cancel = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    setCountdown(0);
  };

  if (countdown > 0) {
    return (
      <div className="flex items-center gap-2.5">
        <div className="text-xs font-bold text-[var(--color-warning-text)]">
          {isPhoto ? "Xác nhận hoàn tất chụp" : "Xác nhận hoàn tất makeup"} trong {countdown}s…
        </div>
        <button
          type="button"
          onClick={cancel}
          className="rounded-md border border-[var(--color-warning)] bg-[var(--color-warning-bg)] px-3 py-1 text-[11px] font-bold text-[var(--color-warning-text)]"
        >
          Hủy
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={start}
      disabled={disabled}
      className="rounded-md border-0 bg-gradient-to-br from-[var(--color-success)] to-[var(--color-success)]/80 px-5 py-2 text-xs font-bold text-white shadow-md disabled:cursor-not-allowed disabled:opacity-60"
    >
      {isPhoto ? "Hoàn tất chụp" : "Hoàn tất makeup"}
    </button>
  );
}
